const text = "'INÍCIO DA MACRO ------------------------------------------------------------------------------\n" +
    "\n" +
    "Sub OnlaineFormatarRelatorio()\n" +
    "            \n" +
    "    'Macro atualizada em 13/06/2025 - Versão 1.5\n" +
    "    'Utilização para formatação para memorial fotográfico\n" +
    "        \n" +
    "        \n" +
    "    Application.ScreenUpdating = False\n" +
    "    Application.DisplayAlerts = False\n" +
    "\n" +
    "    Dim tblCol As Collection\n" +
    "    Dim tbl As Table, masterTbl As Table\n" +
    "    Dim i As Long, r As Long, c As Long\n" +
    "    Dim cel As Cell, rng As Range, txt As String\n" +
    "    Dim rw As Row, shp As Shape\n" +
    "    Dim skipRow As Boolean\n" +
    "    Dim rngInsert As Range, rngDest As Range\n" +
    "    Dim maxCols: maxCols = 0\n" +
    "    \n" +
    "    \n" +
    "    Const PAD_TOP_FOTO As Single = 6      ' em pontos\n" +
    "    Const PAD_BOT_OUTRO As Single = 12    ' em pontos\n" +
    "\n" +
    "    '--- capturar apenas tabelas externas ---\n" +
    "    Set tblCol = New Collection\n" +
    "    For Each tbl In ActiveDocument.Tables\n" +
    "        If tbl.NestingLevel = 1 Then\n" +
    "            \n" +
    "            tblCol.Add tbl\n" +
    "            \n" +
    "            If tbl.Columns.Count > maxCols Then\n" +
    "                maxCols = tbl.Columns.Count\n" +
    "            End If\n" +
    "            \n" +
    "        End If\n" +
    "    Next tbl\n" +
    "        \n" +
    "    'Lembrete: layout 4 fotos precisa de inversão e possui 7 colunas, os demais possuem até 6 colunas\n" +
    "        \n" +
    "    If maxCols > 6 Then\n" +
    "    \n" +
    "        ' === Cria uma nova collection invertida ===\n" +
    "        Set tblColInversa = New Collection\n" +
    "        For i = tblCol.Count To 1 Step -1\n" +
    "            tblColInversa.Add tblCol(i)\n" +
    "        Next i\n" +
    "        \n" +
    "        ' === Substitui a original se quiser trabalhar com a ordem invertida ===\n" +
    "        Set tblCol = tblColInversa\n" +
    "    \n" +
    "        Set tblColInversa = Nothing\n" +
    "    \n" +
    "    End If\n" +
    "\n" +
    "    If tblCol.Count = 0 Then\n" +
    "        MsgBox \"Documento não contém tabelas externas para formatação.\", vbInformation\n" +
    "        GoTo Finaliza\n" +
    "    End If\n" +
    "\n" +
    "    '=== LIMPEZA E AJUSTES ===\n" +
    "    For Each tbl In tblCol\n" +
    "\n" +
    "        'Remover células vazias\n" +
    "        For r = tbl.Rows.Count To 1 Step -1\n" +
    "            For c = tbl.Rows(r).Cells.Count To 1 Step -1\n" +
    "                Set cel = tbl.Rows(r).Cells(c)\n" +
    "                Set rng = cel.Range: rng.End = rng.End - 1\n" +
    "                If rng.InlineShapes.Count = 0 And rng.ShapeRange.Count = 0 Then\n" +
    "                    \n" +
    "                    txt = Trim$(rng.Text)\n" +
    "                    If Len(txt) = 0 Then\n" +
    "                        \n" +
    "                        If cel.ColumnIndex = 1 Or cel.ColumnIndex = cel.Row.Cells.Count Then\n" +
    "                            cel.Delete ShiftCells:=wdDeleteCellsShiftLeft\n" +
    "                            'cel.Shading.BackgroundPatternColor = wdColorRed\n" +
    "                            'cel.Range.Text = cel.ColumnIndex\n" +
    "                        End If\n" +
    "\n" +
    "                    Else\n" +
    "                        \n" +
    "                        If LCase$(Left$(txt, 4)) <> \"foto\" Then\n" +
    "                            cel.Range.Style = \"Título 2\"\n" +
    "                            cel.BottomPadding = PAD_BOT_OUTRO                     ' padding inferior maior\n" +
    "                        Else\n" +
    "                            cel.TopPadding = PAD_TOP_FOTO\n" +
    "                        End If\n" +
    "                        \n" +
    "                    End If\n" +
    "                    \n" +
    "                   \n" +
    "                    \n" +
    "                End If\n" +
    "            Next c\n" +
    "        Next r\n" +
    "\n" +
    "        'Libera altura onde possível\n" +
    "        For Each rw In tbl.Rows\n" +
    "            skipRow = (rw.Range.InlineShapes.Count > 0)\n" +
    "\n" +
    "            If Not skipRow Then\n" +
    "                For Each shp In ActiveDocument.Shapes\n" +
    "                    If Not shp.Anchor Is Nothing Then\n" +
    "                        If shp.Anchor.Start >= rw.Range.Start And shp.Anchor.Start < rw.Range.End Then\n" +
    "                            skipRow = True: Exit For\n" +
    "                        End If\n" +
    "                    End If\n" +
    "                Next shp\n" +
    "            End If\n" +
    "\n" +
    "            If Not skipRow Then\n" +
    "                For Each cel In rw.Cells\n" +
    "                    txt = Trim$(Replace$(cel.Range.Text, Chr$(13) & Chr$(7), \"\"))\n" +
    "                    If LCase$(Left$(txt, 4)) = \"foto\" Then skipRow = True: Exit For\n" +
    "                Next cel\n" +
    "            End If\n" +
    "\n" +
    "            If Not skipRow Then\n" +
    "                rw.HeightRule = wdRowHeightAuto\n" +
    "                rw.Height = 0\n" +
    "            End If\n" +
    "        Next rw\n" +
    "\n" +
    "        tbl.Rows.Alignment = wdAlignRowCenter\n" +
    "        tbl.AllowAutoFit = True\n" +
    "\n" +
    "    Next tbl\n" +
    "\n" +
    "    '=== CRIA TABELA-MESTRE ===\n" +
    "    Set rngInsert = ActiveDocument.Range(0, 0)\n" +
    "    Set masterTbl = ActiveDocument.Tables.Add(rngInsert, 1, 1)\n" +
    "    With masterTbl\n" +
    "        .PreferredWidthType = wdPreferredWidthPercent\n" +
    "        .PreferredWidth = 100\n" +
    "        .AllowAutoFit = False\n" +
    "        .Rows.Alignment = wdAlignRowCenter\n" +
    "    End With\n" +
    "\n" +
    "    '=== COPIA TABELAS ===\n" +
    "    For i = 1 To tblCol.Count\n" +
    "        If masterTbl.Cell(1, 1).Range.Text = Chr$(13) & Chr$(7) Then\n" +
    "            Set rngDest = masterTbl.Cell(1, 1).Range\n" +
    "        Else\n" +
    "            masterTbl.Rows.Add\n" +
    "            Set rngDest = masterTbl.Rows(masterTbl.Rows.Count).Cells(1).Range\n" +
    "        End If\n" +
    "\n" +
    "        rngDest.Collapse wdCollapseStart\n" +
    "        rngDest.FormattedText = tblCol(i).Range.FormattedText\n" +
    "        tblCol(i).Delete\n" +
    "    Next i\n" +
    "       \n" +
    "\n" +
    "    '=== Limpa conteúdo após tabela-mestre ===\n" +
    "    ActiveDocument.Range(masterTbl.Range.End, ActiveDocument.Content.End).Delete\n" +
    "\n" +
    "Finaliza:\n" +
    "    Application.DisplayAlerts = True\n" +
    "    Application.ScreenUpdating = True\n" +
    "\n" +
    "    If tblCol.Count > 0 Then\n" +
    "        ActiveDocument.Content.Select\n" +
    "        Selection.Copy\n" +
    "        MsgBox \"Tudo certo! Basta colar o conteúdo no memorial fotográfico do seu Laudo de Inspeção\", vbInformation\n" +
    "    End If\n" +
    "End Sub\n" +
    "'FIM DA MACRO ------------------------------------------------------------------------------"

export default text